import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Brain,
  Key,
  Users,
  UserCog,
  ScrollText,
  FlaskConical,
  Settings as SettingsIcon,
} from 'lucide-react';

const links = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/models', icon: Brain, label: 'Models' },
  { to: '/keys', icon: Key, label: 'Virtual Keys' },
  { to: '/teams', icon: Users, label: 'Teams' },
  { to: '/users', icon: UserCog, label: 'Internal Users' },
  { to: '/logs', icon: ScrollText, label: 'Logs' },
  { to: '/playground', icon: FlaskConical, label: 'Playground' },
  { to: '/settings', icon: SettingsIcon, label: 'Settings' },
];

export function Sidebar() {
  return (
    <aside
      style={{
        width: 220,
        background: '#fff',
        borderRight: '1px solid #e2e8f0',
        overflowY: 'auto',
      }}
    >
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 12 }}>
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 12px',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: isActive ? 500 : 400,
              color: isActive ? '#0f172a' : '#64748b',
              background: isActive ? '#f1f5f9' : 'transparent',
            })}
          >
            <Icon size={16} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
